<div class="modal-header"><div class="quote-tite italic">{{devUtilsModalConfig.header}}</div></div>
<div class="modal-body" data-cy="DevUtilsModal">
    <div class="row">
        <div class="col-12 col-md-6 mb-2" *ngFor="let scenario of devUtilsModalConfig.scenarios | keyvalue; let index = i"><button class="btn rounded-xl btn-primary text-white w-100" [attr.data-cy]="scenario.value.testId" (click)="performAction(scenario.key)">{{scenario.value.buttonText}}</button></div>
    </div>
</div>
